import moment from 'moment'

export const formatTimestamp = (value, formatDate) => {
  if (value) {
    return moment(value, 'YYYY-MM-DD').format(formatDate)
  }
}

export default { formatTimestamp }
